import { useEffect, useState } from "react";
import { getPublicSiteSettings } from "@/lib/webContentApi";
import { SiteSettings } from "@/lib/webContentTypes";

export const defaultSiteSettings: SiteSettings = {
  aprName: "APR Quechurehue",
  aprFullName: "Comite de Agua Potable Rural Quechurehue",
  payUrl: "/pagar",
  portalUrl: "http://localhost:15174",
  phone: "",
  email: "",
  address: "",
  schedule: "Lunes a Viernes: 09:00 - 14:00 hrs",
  whatsapp: "",
};

export function useSiteSettings(): SiteSettings {
  const [settings, setSettings] = useState<SiteSettings>(defaultSiteSettings);

  useEffect(() => {
    let mounted = true;
    getPublicSiteSettings()
      .then((value) => {
        if (mounted) {
          setSettings({ ...defaultSiteSettings, ...value });
        }
      })
      .catch(() => {
        // keep defaults
      });

    return () => {
      mounted = false;
    };
  }, []);

  return settings;
}
